import {
    ICellMetric,
    ICellMetricAggregator,
    ICellMetricAggregatorCalcLevel,
    ICellMetricPushDownMethod,
    ICellMetricPushDownOptions,
    ICellMetricRenderOptions,
    ICellMetricUOM,
    ICellMetricUOMConverters,
} from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import { WB_ModelPredictorRow } from "../PA.Core/PAdbSchemaRows";
import { WAvgMetricAggr } from "../PA.HyperRectangle.Core/WAvgMetricAggr";
import { AdditiveMetricAggr } from "../PA.HyperRectangle.Core/AdditiveMetricAggr";
import * as _ from "lodash";
import { IUOMPolicyOptions } from "../PA.MD.Services/PA.MD.Services.IF";

export class SimulatorPredictorMetric implements ICellMetric {
    private _metricId: string;
    private _WB_ModelPredictorRow: WB_ModelPredictorRow;
    private _Aggregator: () => ICellMetricAggregator;
    private _bReadOnly: boolean;
    private _groupName: string;
    private _RenderOptions: ICellMetricRenderOptions;
    private _options: { [p: string]: any };

    constructor(
        aPredictorRow: WB_ModelPredictorRow,
        bReadOnly?: boolean,
        sIdPrefix?: string,
        additionalOptions?: { [p: string]: any },
    ) {
        this._WB_ModelPredictorRow = aPredictorRow;
        this._options = { Type: "ModelPredictor" };
        _.defaults(this._options, additionalOptions);

        this._metricId = aPredictorRow.cif.MODEL_PREDICTOR_ID;
        if (!_.isEmpty(sIdPrefix)) this._metricId = sIdPrefix + this._metricId;

        this._groupName = "Simulation Predictor";

        //  determine the aggregator, likely a rate, so
        switch (aPredictorRow.cif.AGGREGATION_METHOD) {
            case "Additive":
                this._Aggregator = () => {
                    return new AdditiveMetricAggr(this._metricId);
                };
                break;

            case "Average":
                this._Aggregator = () => {
                    return new WAvgMetricAggr(this._metricId);
                };
                break;

            default:
                this._Aggregator = () => {
                    return new WAvgMetricAggr(this._metricId);
                };
                break;
        }
        this._bReadOnly = false;
        if (_.isBoolean(bReadOnly)) this._bReadOnly = bReadOnly;

        this._RenderOptions = { numberType: aPredictorRow.cif.NUMBER_TYPE };
        if (aPredictorRow.cif.MIN_VALUE_IND == "1") this._RenderOptions.minValue = aPredictorRow.cif.MIN_VALUE;

        if (aPredictorRow.cif.MAX_VALUE_IND == "1") this._RenderOptions.maxValue = aPredictorRow.cif.MAX_VALUE;
    }

    get MetricId(): string {
        return this._metricId;
    }

    get MetricName(): string {
        return this._WB_ModelPredictorRow.cif.MODEL_PREDICTOR_NAME;
    }

    get MetricFieldName(): string {
        return this._WB_ModelPredictorRow.cif.MODEL_PREDICTOR_ID;
    }

    get Options(): { [p: string]: any } {
        return this._options;
    }

    get AggregatorCalcLevel(): ICellMetricAggregatorCalcLevel {
        return ICellMetricAggregatorCalcLevel.Leaf;
    }

    get bIsHidden(): boolean {
        return false;
    }

    get bIsLeafLevelOnly(): boolean {
        return false;
    }

    get Aggregator(): () => ICellMetricAggregator {
        return this._Aggregator;
    }

    get Sort(): number {
        return this._WB_ModelPredictorRow.cif.SORT_ORDER_UI;
    }

    get GroupName(): string {
        return this._groupName;
    }

    get RenderOptions(): ICellMetricRenderOptions {
        return this._RenderOptions;
    }

    get SupportingMetricsIds(): string[] {
        return [];
    }

    get bIsReadOnly(): boolean {
        return this._bReadOnly;
    }

    get PushDownMethod(): ICellMetricPushDownMethod {
        switch (this._WB_ModelPredictorRow.cif.AGGREGATION_METHOD) {
            case "Additive":
                return ICellMetricPushDownMethod.Reallocate;
            case "Average":
                return ICellMetricPushDownMethod.CopyDown;
        }

        return ICellMetricPushDownMethod.CopyDown;
    }

    get PushDownOptions(): ICellMetricPushDownOptions {
        return {};
    }

    getMetricUOM(options?: IUOMPolicyOptions): ICellMetricUOM | Promise<ICellMetricUOM> {
        return {
            NumeratorUOM: { bUOM: false, UOMCode: undefined, bCurrency: false, CurrencyCode: undefined },
            DenominatorUOM: { bUOM: false, UOMCode: undefined, bCurrency: false, CurrencyCode: undefined },
        };
    }

    getMetricUOMConverters(): ICellMetricUOMConverters {
        return { NumeratorUOMConverters: [], DenominatorUOMConverter: [] };
    }
}
